export const deviceStatus = Object.freeze([
  { id: 'Active', name: 'Active' },
  { id: 'Deactivated', name: 'Deactivated' },
]);
